import { getGridStringOperators } from "@mui/x-data-grid-pro";
import VerifiedIcon from "@mui/icons-material/GppGood";
import UnverifiedIcon from "@mui/icons-material/GppBad";
import { timestampColumn } from "../../DataGrid/ColumnHelpers";
import BadgeIcon from "@mui/icons-material/Badge";
import ErrorIcon from "@mui/icons-material/Error";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { Tooltip } from "@mui/material";

const filterOperators = getGridStringOperators().filter(
  (operator) => operator.value === "equals"
);

export const columns = [
  {
    field: "isVerified",
    headerName: "Verified",
    width: 80,
    filterOperators,
    type: "boolean",
    renderCell: ({ value }) => {
      return value ? (
        <VerifiedIcon color="success" />
      ) : (
        <UnverifiedIcon color="disabled" />
      );
    },
  },
  {
    field: "userAccountStatus",
    headerName: "Account",
    width: 80,
    filterOperators,
    renderCell: ({ value, row }) => {
      if (value === "created") {
        return (
          <Tooltip
            title={
              row.isVerified
                ? "User exists - login enabled"
                : "User exists - login disabled"
            }
          >
            <BadgeIcon color={row.isVerified ? "success" : "warning"} />
          </Tooltip>
        );
      }
      if (value === "failed") {
        return (
          <Tooltip title="Error when creating user account">
            <ErrorIcon color="error" />
          </Tooltip>
        );
      }
      return (
        <Tooltip title="User account status unknown">
          <QuestionMarkIcon color="disabled" />
        </Tooltip>
      );
    },
  },
  {
    field: "companyName",
    headerName: "Company Name",
    description: "",
    sortable: false,
    width: 180,
    filterOperators,
  },
  {
    field: "companyNumber",
    headerName: "Company Number",
    width: 160,
    filterOperators,
  },
  {
    field: "contactEmail",
    headerName: "Email",
    sortable: false,
    width: 160,
    filterOperators,
  },
  {
    field: "contactNumber",
    headerName: "Contact Number",
    type: "string",
    width: 150,
    filterOperators,
  },
  {
    field: "address",
    headerName: "Address",
    type: "string",
    width: 250,
    filterOperators,
  },
  {
    field: "postcode",
    headerName: "Postcode",
    type: "string",
    width: 150,
    filterOperators,
  },
  timestampColumn({
    field: "createdAt",
    headerName: "Created At",
  }),
];
